export default "__VITE_ASSET__CPUGkK9h__"